import React from 'react';
import '../styles/About.css';

const About = () => {
  return (
    <div className="about-page">
      <section className="about-hero">
        <div className="container">
          <h1 className="fade-in">Our Sweet Story</h1>
          <p className="about-hero-subtitle fade-in">
            Where passion meets perfection in every bite
          </p>
        </div>
      </section>

      <section className="about-content section">
        <div className="container">
          <div className="about-grid">
            <div className="about-text slide-in-left">
              <h2>Welcome to Cakified</h2>
              <p>
                Since 2025, Cakified has been crafting premium cakes, jar cakes, and brownies 
                that bring joy to every celebration. Our journey began with a simple belief: 
                every dessert should be a work of art, made with love and the finest ingredients.
              </p>
              <p>
                What started as a passion project in a home kitchen has blossomed into a beloved 
                bakery known for creating memorable moments, one delicious treat at a time.
              </p>
            </div>
            <div className="about-image slide-in-right">
              <img 
                src="https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=600&h=400&fit=crop&q=80" 
                alt="Baking with love"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="about-values section">
        <div className="container">
          <div className="section-title">
            <h2>Our Values</h2>
          </div>
          
          <div className="values-grid">
            <div className="value-card fade-in">
              <div className="value-icon">🌟</div>
              <h3>Quality First</h3>
              <p>
                We source only premium ingredients - from Belgian chocolate to real vanilla. No compromises, no shortcuts.
              </p>
            </div>

            <div className="value-card fade-in">
              <div className="value-icon">🎨</div>
              <h3>Artisan Craftsmanship</h3>
              <p>
                Every cake, brownie, and jar cake is handcrafted by skilled bakers who treat 
                each creation as their masterpiece.
              </p>
            </div>

            <div className="value-card fade-in">
              <div className="value-icon">💚</div>
              <h3>Freshness Guaranteed</h3>
              <p>
                All our products are made to order. We bake fresh daily, ensuring you receive 
                the finest quality every single time.
              </p>
            </div>

            <div className="value-card fade-in">
              <div className="value-icon">🎂</div>
              <h3>Custom Creations</h3>
              <p>
                Whether it's a birthday, anniversary, or just because - we create personalized 
                treats that make your moments special.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="about-promise section">
        <div className="container">
          <div className="promise-content">
            <h2>Our Promise to You</h2>
            <div className="promise-list">
              <div className="promise-item">
                <span className="promise-check">✓</span>
                <div>
                  <h4>100% Fresh Ingredients</h4>
                  <p>No preservatives, no artificial flavors - just pure, natural goodness</p>
                </div>
              </div>
              
              <div className="promise-item">
                <span className="promise-check">✓</span>
                <div>
                  <h4>Made to Order</h4>
                  <p>Every dessert is baked fresh when you order, never pre-made</p>
                </div>
              </div>
              
              <div className="promise-item">
                <span className="promise-check">✓</span>
                <div>
                  <h4>Hygiene Standards</h4>
                  <p>Maintained with the highest cleanliness and safety protocols</p>
                </div>
              </div>
              
              <div className="promise-item">
                <span className="promise-check">✓</span>
                <div>
                  <h4>Customer Satisfaction</h4>
                  <p>Your happiness is our priority - we're not satisfied until you are</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="about-cta section">
        <div className="container">
          <div className="cta-box">
            <h2>Ready to Experience Cakified?</h2>
            <p>Join thousands of happy customers who trust us for their sweet moments</p>
            <a href="/#cakes" className="btn btn-primary">
              Explore Our Menu
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
